import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { MONTHLY_COMMIT_MONTHLY_PAY } from 'self-service-api/constants/DTBOfferTerms';
import { getAdditionSeatsSkuId } from '../experiments/acq151/ACQ151Utils';
export const requestUpdateDtbId = state => {
  const additionalSeatsConfig = state.purchase.additionalSeats > 0 ? [{
    skuId: getAdditionSeatsSkuId(),
    quantity: state.purchase.additionalSeats
  }] : [];
  return noAuthApiClient.post(`monetization/v3/direct-to-buy/public`, {
    data: {
      currencyCode: 'USD',
      productBasedOfferIds: [],
      offerTerms: [MONTHLY_COMMIT_MONTHLY_PAY],
      productConfigurations: [{
        skuId: state.purchase.productInfo.skuId,
        quantity: state.purchase.productInfo.quantity
      }, ...additionalSeatsConfig]
    }
  });
};